module.exports = __webpack_public_path__ + "img/12217_5.554fc8d3.png";